import { render, staticRenderFns } from "./appraiseDetail.vue?vue&type=template&id=6265d74e&scoped=true"
import script from "./appraiseDetail.vue?vue&type=script&lang=js"
export * from "./appraiseDetail.vue?vue&type=script&lang=js"
import style0 from "./appraiseDetail.vue?vue&type=style&index=0&id=6265d74e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6265d74e",
  null
  
)

export default component.exports